// extracted by mini-css-extract-plugin
module.exports = {"container":"insights_container__cIHaF","title":"insights_title__1iqFd","list_container":"insights_list_container__hwyRb","list_item":"insights_list_item__3J_bU"};